import { HRISProvider } from '@/types/hrisIntegration';

export type HrisProviderOption = {
  id: string;
  label: string;
  value: string;
  name: string;
};

export const transformHrisProvidersToOptions = (
  hrisProviders: HRISProvider[] | undefined
): HrisProviderOption[] => {
  if (!hrisProviders) {
    return [];
  }

  return hrisProviders.map((provider: HRISProvider) => ({
    id: provider.id,
    value: provider.slug ?? '',
    name: provider.name,
    label: provider.slug,
  }));
};
